import { CSSInterpolation } from '@emotion/css/create-instance'
import { keyframes } from '@emotion/react'
import React from 'react'

const fadeKeyframes = keyframes`
  0% {
    opacity: 1;
  }
  64%,
  100% {
    opacity: 0;
  }
`

export const SPINNER_SIZE = '24px'
const animationDuration = 800
const numLegs = 12

type Props = {
  /**
   * A CSS value to use as the color for the spinner.
   */
  color: string
  /**
   * Pass a CSS object if you need to override styles on the root element. Please do this
   * sparingly.
   */
  overrideRootStyles?: CSSInterpolation
}

/**
 * @deprecated this component is exported for legacy use within `web-static-sites`.
 *
 * You should use a `Spinner*` component instead.
 */
export function ThemelessLegacySpinner({ color, overrideRootStyles }: Props) {
  const legCss: CSSInterpolation = {
    animation: `${fadeKeyframes} ${animationDuration}ms infinite`,
    backgroundColor: color,
    borderRadius: '1px',
    height: '25%',
    left: '46%',
    opacity: 0,
    position: 'absolute',
    top: 0,
    transformOrigin: 'center 200%',
    width: '8%',
  }
  for (let i = 0; i < numLegs; i += 1) {
    legCss[`&:nth-of-type(${i})`] = {
      animationDelay: `${(i * animationDuration) / numLegs}ms`,
      transform: `rotate(${(360 * i) / numLegs}deg)`,
    }
  }
  return (
    <div
      css={[
        {
          height: SPINNER_SIZE,
          position: 'relative',
          width: SPINNER_SIZE,
        },
        overrideRootStyles,
      ]}
      data-loading="true"
    >
      {new Array(numLegs).fill(0).map((_, index) => (
        <div key={index} css={legCss} />
      ))}
    </div>
  )
}
